"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathThirdParty = exports.PathExtension = exports.PathMeetingBooker = void 0;
const config_1 = require("@/app/shared/config");
exports.PathMeetingBooker = {
    HOME: '/',
    WRAPPER: '/wrapper',
    LOGIN: '/login',
    INSTALLED: '/installed',
    REDIRECT_GOOGLE: '/redirect/google',
    REDIRECT_MICROSOFT: '/redirect/microsoft',
    REDIRECT_SALESFORCE: '/services/oauth2/success',
};
exports.PathExtension = {
    WRAPPER: `${config_1.Config.SUMO_ENV_EXTENSION_ORIGIN}${exports.PathMeetingBooker.WRAPPER}`,
    REDIRECT_GOOGLE: `${config_1.Config.SUMO_ENV_EXTENSION_ORIGIN}${exports.PathMeetingBooker.REDIRECT_GOOGLE}`,
    REDIRECT_MICROSOFT: `${config_1.Config.SUMO_ENV_EXTENSION_ORIGIN}${exports.PathMeetingBooker.REDIRECT_MICROSOFT}`,
    REDIRECT_SALESFORCE: `${config_1.Config.SUMO_ENV_EXTENSION_ORIGIN}${exports.PathMeetingBooker.REDIRECT_SALESFORCE}`,
};
exports.PathThirdParty = {
    GMAIL_HOME: 'https://mail.google.com/',
    OUTLOOK_LIVE_HOME: 'https://outlook.live.com/',
};
